<template>
  <ui-row>
    <ui-col>
      <ui-card class="home-page" v-if="authInfo">
        <ui-image class="user-home-header" cover :src="background">
          <ui-avatar
            size="lg"
            :url="authInfo.avatar"
            :username="authInfo.username"
            >{{ $t($route.name) }}</ui-avatar
          >
        </ui-image>

        <router-view :key="$route.fullPath"></router-view>
      </ui-card>
    </ui-col>
  </ui-row>
</template>
<script>
import api from "../api/index";
import { mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["authInfo"]),
    background() {
      return this.authInfo.avatar && this.authInfo.avatar.replace(/\?x.*/, "");
    }
  }
};
</script>
